import config from './utils/config';

// load and modify onetrust tag based on cookies
document.addEventListener('DOMContentLoaded', () => {
    const onetrustScript = document.createElement('script');
    onetrustScript.src = `https://cdn.cookielaw.org/consent/${config.onetrustToken}/otSDKStub.js`;
    onetrustScript.setAttribute('charset', 'UTF-8');
    onetrustScript.setAttribute('data-domain-script', config.onetrustToken);
    onetrustScript.setAttribute('data-disable-inline', 'true');
    onetrustScript.setAttribute('amp', 'true');

    const firstScriptTag = document.getElementsByTagName('script')[0];
    if (!document.querySelector('script[src^="https://cdn.cookielaw.org"]')) {
        if (firstScriptTag) {
            firstScriptTag.parentNode.insertBefore(onetrustScript, firstScriptTag);
        } else {
            document.head.appendChild(onetrustScript);
        }
    }
});

